var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Commentary/Events/Standard.js";

var Standard = function Standard(_ref) {
  var title = _ref.title,
      content = _ref.content;
  return _react.default.createElement(_react.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Row, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 9
    }
  }, title ? _react.default.createElement(_Basic.Text, {
    bold: true,
    fontSize: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 17
    }
  }, title) : null), content ? _react.default.createElement(_Basic.Text, {
    fontSize: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 20
    }
  }, content) : null);
};

Standard.propTypes = {
  title: _propTypes.default.string,
  content: _propTypes.default.string
};
var _default = Standard;
exports.default = _default;